import {
  DARKEST_GREY,
  PRIMARY_BLUE,
  GRAY_BACKGROUND_2,
  OPACITY_LIGHT,
  WHITE,
  combinedColor,
} from '~/Constants/Colors.constants';
import {
  FONT_SIZE_LARGISH,
  FONT_SIZE_XX_LARGER,
  Z_INDEX_PRODUCT_TOUR_OVERLAY,
} from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const useProductToursStyles = makeStyles(
  (theme) => ({
    container: {
      textAlign: 'center',
    },
    icon: {
      '& svg': {
        color: PRIMARY_BLUE,
        fontSize: 70,
      },
    },
    title: {
      fontSize: FONT_SIZE_LARGISH,
      lineHeight: '28px',
      fontWeight: 'bold',
      margin: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: FONT_SIZE_XX_LARGER,
        lineHeight: '42px',
        letterSpacing: '-0.75px',
      },
      marginBottom: 24,
      paddingBottom: 24,
      borderBottom: `1px solid ${GRAY_BACKGROUND_2}`,
      letterSpacing: -0.75,
    },
    closeButton: {
      position: 'absolute',
      top: 8,
      right: 8,
    },
    arrow: {
      position: 'absolute',
      transform: 'translate(0px, 100px)',
      inset: '0px auto auto 0px',
      '&::before': {
        transition: 'transform 0.2s ease-out 0s, visibility 0.2s ease-out 0s',
        visibility: 'visible',
        transform: 'translateX(0px) rotate(45deg)',
        transformOrigin: 'center center',
        content: `" "`,
        background: WHITE,
        top: -30,
        left: -5,
        width: 10,
        height: 10,
        position: 'absolute',
      },
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: combinedColor(DARKEST_GREY, OPACITY_LIGHT),
      zIndex: Z_INDEX_PRODUCT_TOUR_OVERLAY,
      cursor: 'pointer',
    },
    button: {
      marginTop: 8,
      [theme.breakpoints.up('md')]: {
        marginTop: 0,
        marginLeft: 30,
      },
    },
    description: {
      marginBottom: 15,
    },
    buttonContainer: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
  }),
  { name: 'ProductTour' },
);
